/*
  Colour strikethrough (product page)

  Marks colour swatches that are sold out in the size the customer has selected.
  - Data: each .ProductItem__ColorSwatchLink carries data-sizes-in-stock="|S|M|L|"
    (rendered in snippets/product-meta.liquid).
  - Trigger: the theme's "variant:changed" event (fired when a size is picked).
  - On/off: Theme settings > Product page > "Strike through colours sold out in the selected size".
  Marked colours stay clickable, so customers can still open them and sign up for back in stock.
*/
(function () {
  if (window.__colourStrikethroughLoaded) return;
  window.__colourStrikethroughLoaded = true;

  var MARK_CLASS = 'is-sold-out-in-size';
  var LINK_SELECTOR = '.ProductItem__ColorSwatchLink[data-sizes-in-stock]';

  function ensureLine(link) {
    var wrapper = link.querySelector('.SwatchWrapper');
    if (!wrapper || wrapper.querySelector('.ColourStrikethrough__Line')) return;
    var line = document.createElement('span');
    line.className = 'ColourStrikethrough__Line';
    line.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(line);
  }

  function update(scope, size) {
    var links = scope.querySelectorAll(LINK_SELECTOR);

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var inStock = link.getAttribute('data-sizes-in-stock') || '';
      var soldOut = !!size && inStock.indexOf('|' + size + '|') === -1;

      link.classList.toggle(MARK_CLASS, soldOut);

      if (soldOut) {
        ensureLine(link);
        var list = link.closest('.ProductItem__ColorSwatchList');
        var label = list ? list.getAttribute('data-sold-out-label') : '';
        var img = link.querySelector('img');
        var colour = img ? img.getAttribute('alt') : '';
        if (colour && label) link.setAttribute('aria-label', colour + ' – ' + label);
      } else {
        link.removeAttribute('aria-label');
      }
    }
  }

  function scopeFor(element) {
    return (element && element.closest && element.closest('.shopify-section')) || document;
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    var size = variant && variant.option1 ? String(variant.option1) : null;
    update(scopeFor(event.target), size);
  });

  function init() {
    // A size can already be selected on load (e.g. ?variant= in the URL)
    var checked = document.querySelectorAll('.ProductForm .SizeSwatch__Radio:checked');
    for (var i = 0; i < checked.length; i++) {
      update(scopeFor(checked[i]), checked[i].value);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- PREVIEW ONLY: low-stock line ("Only 3 left") in the same row as the size buttons.
   Copies the text from the theme's own (hidden) .ProductForm__Inventory element, which the theme
   fills in and shows/hides per size based on the "Inventory quantity threshold" section setting.
   Remove this block before going live unless we decide to keep it. ---- */
(function () {
  if (window.__stockCountPreviewLoaded) return;
  window.__stockCountPreviewLoaded = true;

  var syncers = [];

  function setup(form) {
    var source = form.querySelector('.ProductForm__Inventory');
    var list = form.querySelector('.SizeSwatchList');
    if (!source || !list || form.querySelector('.LowStockLine')) return;

    var section = form.closest('.shopify-section') || document.body;
    var line = document.createElement('li');
    line.className = 'LowStockLine';
    line.setAttribute('role', 'status');
    line.hidden = true;

    function place() {
      // While showing: sit in the size row, right after the last size button, so nothing below
      // moves. While hidden: park outside the list, because custom.js auto-selects one-size
      // products by checking that the size list has exactly one item.
      if (!line.hidden) {
        var sizes = list.querySelectorAll('.SizePicker');
        var last = sizes[sizes.length - 1];
        if (last && last.nextElementSibling !== line) last.insertAdjacentElement('afterend', line);
      } else if (list.nextElementSibling !== line) {
        list.insertAdjacentElement('afterend', line);
      }
    }

    function sync() {
      var picked = section.classList.contains('is-size-picked');
      var text = (source.textContent || '').trim();
      var visible = picked && source.style.display !== 'none' && text !== '';
      var newText = visible ? text : '';
      if (line.textContent !== newText) line.textContent = newText;
      if (line.hidden === visible) line.hidden = !visible;
    }

    function refresh() {
      sync();
      place();
    }

    refresh();
    syncers.push(refresh);

    // Changes guarded above, so the observer settles instead of looping
    new MutationObserver(refresh).observe(form, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  function syncAll() {
    for (var i = 0; i < syncers.length; i++) syncers[i]();
  }

  function markSizePicked(element) {
    var section = (element && element.closest && element.closest('.shopify-section')) || document.body;
    section.classList.add('is-size-picked');
  }

  document.addEventListener('variant:changed', function (event) {
    if (event.detail && event.detail.variant) markSizePicked(event.target);
    syncAll();
  });

  function init() {
    var forms = document.querySelectorAll('.ProductForm');
    for (var i = 0; i < forms.length; i++) setup(forms[i]);

    var checked = document.querySelectorAll('.ProductForm .SizeSwatch__Radio:checked');
    for (var j = 0; j < checked.length; j++) markSizePicked(checked[j]);
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
